document.addEventListener('alpine:init', () => {
    console.log('[Product] Alpine.js initialized');
    Alpine.data('ProductVariantSelector', (jsonId) => {
        let data = { variants: [], defaultPrice: '', defaultComparePrice: '', firstVariantId: null };
        try {
            const el = document.getElementById(jsonId);
            if (el) {
                data = JSON.parse(el.textContent);
                console.log('[Product] Data loaded from JSON:', data);
            } else {
                console.warn('[Product] JSON script element not found:', jsonId);
            }
        } catch (e) {
            console.error('[Product] Failed to parse product JSON', e);
        }

        const initialVariants = data.variants || [];
        const defaultPrice = data.defaultPrice || '';
        const defaultComparePrice = data.defaultComparePrice || '';
        const firstVariantId = data.firstVariantId;

        // Find the first available variant, fallback to first variant
        const firstAvailableVariant = initialVariants.find(v => v.available) || initialVariants[0];
        let initialVariantId = String(firstAvailableVariant ? firstAvailableVariant.id : (firstVariantId || ''));

        console.log('[Product] Final Initialized ID:', initialVariantId);

        return {
            variants: initialVariants,
            selectedVariantId: initialVariantId,
            defaultPrice: defaultPrice,
            defaultComparePrice: defaultComparePrice,
            swiper: null,
            activeIndex: 0,
            init() {
                if (!this.selectedVariantId && this.variants.length > 0) {
                    this.selectedVariantId = String(this.variants[0].id);
                }
                console.log('[Product] Alpine Component Initialized, ID:', this.selectedVariantId);

                // Wait for swiper to be ready
                this.$nextTick(() => {
                    if (this.$refs.mainSlider) {
                        this.swiper = new Swiper(this.$refs.mainSlider, {
                            slidesPerView: 1,
                            spaceBetween: 0,
                            loop: false,
                            pagination: {
                                el: '.swiper-pagination',
                                clickable: true,
                            },
                            navigation: {
                                nextEl: '.swiper-button-next',
                                prevEl: '.swiper-button-prev',
                            },
                            on: {
                                slideChange: () => {
                                    this.activeIndex = this.swiper.activeIndex;
                                }
                            }
                        });

                        // Go to the initial variant image if possible
                        const variant = this.selectedVariant;
                        if (variant && variant.image_index >= 0 && this.swiper) {
                            this.swiper.slideTo(variant.image_index);
                        }
                    }
                });
            },
            get selectedVariant() {
                return this.variants.find(v => String(v.id) === String(this.selectedVariantId)) || null;
            },
            get displayPrice() {
                return this.selectedVariant ? this.selectedVariant.formatted_price : this.defaultPrice;
            },
            get displayCompareAtPrice() {
                return this.selectedVariant ? this.selectedVariant.formatted_compare_at_price : this.defaultComparePrice;
            },
            get hasDiscount() {
                if (this.selectedVariant) {
                    return this.selectedVariant.compare_at_price > this.selectedVariant.price;
                }
                // Fallback to basic logic if no variant selected (for robustness)
                return this.defaultComparePrice && this.defaultComparePrice !== '';
            },
            get isAvailable() {
                if (!this.selectedVariant) return true;
                return this.selectedVariant.available;
            },
            selectVariant(id) {
                this.selectedVariantId = String(id);
                const variant = this.selectedVariant;
                if (variant && variant.image_index >= 0 && this.swiper) {
                    this.swiper.slideTo(variant.image_index);
                }
            }
        };
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(entries[0].target);

        const url = entries[0].target.dataset.url;

        fetch(url)
            .then(response => response.text())
            .then(responseText => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const recommendations = html.querySelector('.product-recommendations');

                if (recommendations && recommendations.innerHTML.trim().length) {
                    entries[0].target.innerHTML = recommendations.innerHTML;
                }
            })
            .catch(e => {
                console.error(e);
            });
    };

    const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 400px 0px' });

    const recommendationSection = document.querySelector('.product-recommendations');
    if (recommendationSection) {
        observer.observe(recommendationSection);
    }
});
